import React from "react";
import PicksCard from "../../assets/HomePicksCard.svg";
import PicksCard2 from "../../assets/HomePicksCard2.svg";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import { isMobile } from "../../types/type";
import { Oval } from "react-loader-spinner";
interface PicksProps {
  marginTop?: string | number;
  className?: string;
  marginBottom?: string | number;
  marginLeft?: string | number;
  marginRight?: string | number;
  numberOfPeople?: string;
  onClick?: () => void;
  loader: { index: number; visible: boolean };
}

function MatchMyPickButtonContainer({
  className,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  numberOfPeople,
  loader,
  onClick,
}: PicksProps) {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`cardMatchMyPickButtonContainer ${className}`}
      style={{ marginBottom, marginLeft, marginRight, marginTop }}
      onClick={handleOnClick}
    >
      <CustomText
        size="smallMedium"
        weight="500"
        marginTop={isMobile ? 0 : -10}
        color={Colors.primary}
      >
        {numberOfPeople} players have made picks
      </CustomText>
      {/* <div className="cardMatchMyPickButtonContainerTextContainer">
        <div className="cardMatchMyPickButtonContainerText">
        </div>
      </div> */}

      <div className="cardMatchMyPickButtonContainerButtonContainer">
        <div className="cardMatchMyPickButtonContainerButtonBackground pointer">
          <div className="cardMatchMyPickButtonContainerButton">
            {loader.index === 1 && loader.visible === true && (
              <Oval
                height={30}
                width={30}
                color="orangered"
                wrapperStyle={{ justifyContent: "center" }}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="gray"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            )}
            {(loader.index !== 1 || !loader.visible) && (
              <CustomText size="small" weight="500" color={Colors.brownPrimary}>
                MY PICKS
              </CustomText>
            )}
          </div>
        </div>
      </div>

      {/* <img src={PicksCard} alt="" className="cardMatchMyPickButtonImage" /> */}
      {/* <img src={PicksCard2} alt="" className="cardMatchMyPickButtonImage2" /> */}
    </div>
  );
}

export default MatchMyPickButtonContainer;
